



































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { TagsGrid } from "@/components.tags/tags-grid";

export default defineComponent({

	emits:[],
	props:{
	},
	components:{
		TagsGrid
	},
	setup(){
		
		

		return {

		};
	}
});

